import { Typography } from "@mui/material";
import React from "react";
import ExportedProformaEmployeeCostReportCostSchema from "./ExportedProformaEmployeeCostReportCostSchema";
import ExportedProformaEmployeeCostReportHeader from "./ExportedProformaEmployeeCostReportHeader";
import { CustomDate } from "../../../models/custom-date/custom-date";
import { ProformaEmployeeCostReportDTO } from "../../../models/proforma-employee-cost-report/proforma-employee-cost-report-dto";
import { intlFormatDateShort } from "../../../utils/time-utils";
import { Container, ReportContainer } from "../styles";
import ExportedProformaEmployeeCostReportPaySchema from "./ExportedProformaEmployeeCostReportPaySchema";

interface Props {
  report: ProformaEmployeeCostReportDTO;
  exportedBlocks: {
    paySchema: boolean;
    costSchema: boolean;
    sectionsWithZeroAmount: boolean;
  };
  monthlyView: boolean;
}
const ExportedProformaEmployeeCostReport = ({ report, exportedBlocks, monthlyView }: Props) => {
  return (
    <ReportContainer>
      <Typography variant="h4">Proforma employee cost report</Typography>
      <ExportedProformaEmployeeCostReportHeader
        // project={report.project}
        // employee={report.employee}
        description={report.description}
        currency={report.currency?.code ?? ""}
        from={report.applicableFrom ? intlFormatDateShort(CustomDate.ToDate(report.applicableFrom)!) : ""}
        // to={!!report.applicableTo ? intlFormatDateShort(CustomDate.ToDate(report.applicableTo)!) : ""}
      />
      <Container style={{ overflow: "visible", maxHeight: "unset" }}>
        {exportedBlocks.costSchema ? (
          <ExportedProformaEmployeeCostReportCostSchema
            selectedPeriod={report.selectedPeriod}
            costSchemaSections={report.sections
              .filter((section) =>
                !section.type?.type?.isPaySchemaRelated && exportedBlocks.sectionsWithZeroAmount
                  ? exportedBlocks.sectionsWithZeroAmount
                    ? true
                    : section.amount > 0
                  : false
              )
              .sort((a, b) => (a.type?.sequence ?? 0) - (b.type?.sequence ?? 0))}
            monthlyView={monthlyView}
          />
        ) : (
          <></>
        )}
        {exportedBlocks.paySchema ? (
          <ExportedProformaEmployeeCostReportPaySchema
            paySchemaSections={report.sections
              .filter((section) =>
                section.type?.type?.isPaySchemaRelated && exportedBlocks.sectionsWithZeroAmount
                  ? exportedBlocks.sectionsWithZeroAmount
                    ? true
                    : section.amount > 0
                  : false
              )
              .sort((a, b) => (a.type?.sequence ?? 0) - (b.type?.sequence ?? 0))}
            monthlyView={monthlyView}
          />
        ) : (
          <></>
        )}
      </Container>
    </ReportContainer>
  );
};

export default ExportedProformaEmployeeCostReport;
